import { css, cx } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import { AuthorsGridBar } from './AuthorsGridBar'
import { AuthorStat } from '../../types'
import { AuthorsGridBarMotion } from './AuthorsGridBarMotion'
import { getStatsAuthors } from '../../lib/utils'

interface Props {
  animate: boolean
}

export const AuthorsGridMain = ({ animate }: Props) => {
  const stats = useStats((s) => s.stats)
  const maxBookCount = 10
  const authors = getStatsAuthors(stats) || []

  const getContent = (author: AuthorStat, i: number) => {
    const highlight = i === 0
    if (!animate)
      return (
        <AuthorsGridBar
          key={i}
          highlight={highlight}
          max={maxBookCount}
          animate={false}
          show
          {...author}
        />
      )

    return (
      <AuthorsGridBarMotion
        key={i}
        highlight={highlight}
        max={maxBookCount}
        {...author}
      />
    )
  }

  return (
    <div
      className={cx(
        css`
          display: grid;
          grid-template-columns: repeat(${maxBookCount}, 1fr);
          grid-auto-rows: 28px;
          gap: 14px;
        `,
        'stats-authors-grid-bars'
      )}
    >
      {authors.map((a, i) => getContent(a, i))}
    </div>
  )
}
